function PageHero({ title, text }) {
  return (
    <section className="page-hero">
      <span className="eyebrow">R&Do Ltd.</span>
      <h1>{title}</h1>
      <p>{text}</p>
    </section>
  );
}

export default PageHero;